<template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left>
      {{ recordInfo.recordName || '--' }}提交信息
    </template>
    <div class="scroll_wrap">
      <vue-scroll v-show="!loading">
        <div class="info_item">
          <div class="info_title">
            <img src="@/assets/images/common/player_information.png" alt="">
            基本信息
          </div>
          <div class="base_info">
            <div class="col">
              <span>被认定高水平赛事名称：{{recordInfo.recordName}}</span>
            </div>
            <div class="col">
              <span>成绩标准：{{scoreInfo}}</span>
            </div>
            <div class="col">
              <span>提交总数：{{ '--' }}</span>
              <span>参赛总积分：{{ '--' }}</span>
            </div>
            <div class="col">
              <span>待审核：{{ '--' }}</span>
              <span>审核驳回：{{ '--' }}</span>
              <span>审核拒绝：{{ '--' }}</span>
              <span>审核通过：{{ '--' }}</span>
            </div>
          </div>
        </div>
        <div class="info_item">
          <div class="info_title between">
            <div class="flex_box">
              <img src="@/assets/images/common/player_squad.png" alt="">
              提交统计
            </div>
          </div>
          <div class="score_wrap">
            <div class="pie" ref="pie"></div>
            <div class="bar" ref="bar"></div>
          </div>
        </div>

        <div class="info_item">
          <div class="info_title between">
            <div class="flex_box">
              <img src="@/assets/images/common/player_squad.png" alt="">
              提交球队详情
            </div>
          </div>
          <div class="score_wrap">

          </div>
          <yioks-empty v-if="squad.length === 0" :h="'200px'"></yioks-empty>
        </div>
      </vue-scroll>
      <yioks-loading v-if="loading"></yioks-loading>
    </div>
  </SubContent>
</template>

<script>

import coach from '@/api/coach'
import squad from "@/api/squad";
import tutorial from '@/api/tutorial'
import { filterIdNumber, coachNatureFilters,coachClassLevel } from '@/utils/yioks_filter'
import squadImg from '@/assets/images/common/squad.png'
import storage from '@/utils/storage'
import record from '@/api/record'
import echarts from "echarts/lib/echarts";
import "echarts/lib/chart/pie"; // 饼图
import "echarts/lib/chart/bar"; // 柱状图
import "echarts/lib/component/tooltip"; // 提示框组件
import "echarts/lib/component/title"; // 标题组件
import "echarts/lib/component/legend"; // 标签组件
export default {
  components: {
    'SubContent': () => import('@/components/layout/newSubContent')
  },
  filters: {
    filterIdNumber,
    coachNatureFilters,
    coachClassLevel,
  },
  data () {
    return {
      coachUuid: this.$route.query.uuid,
      recordUuid: this.$route.query.uuid,
      loading: true,
      squadImg,
      coach: '',
      userRole: storage.get('userInfo').userRole,
      squad: [],
      tutorial: [],
      total: 0,
      whiteUuidList: [],
      recordInfo: {},
      scoreInfo:"",

    }
  },
  created () {
    // this.getInfo()
    // this.getTutorial()
    // this.getWhiteUuidList();
    this.getRecordInfo() // 获取详情接口
  },
  methods: {
    // 编辑详情接口
    getRecordInfo() {
      this.loading = true
      record.getRecordInfo(this.recordUuid).then(res => {
        if (res.code) {
          this.$message.error(res.msg)
        }
        this.recordInfo = res;
        this.loading = false;

        // 设置成绩
        res.recordToScoreList.map(item => {
          this.scoreInfo = this.scoreInfo + "第"+item.ranking+"名("+item.score+"分)，"
        })
        if (this.scoreInfo){
          this.scoreInfo = this.scoreInfo.substring(0,this.scoreInfo.length-1);
        }

      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },



    getInfo () {
      coach.getCoachInfo(this.coachUuid).then(res => {
        if (res.code) {
          this.$message.error(res.msg)
          this.$router.push('/')
        } else {
          this.loading = false
          this.coach = res.coachInformation
          if (Object.keys(res.squadInformation).length > 0) {
            this.squad = res.squadInformation
          }
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },
    getTutorial () {
      let request
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = tutorial.getPersonTutorialBySystem
      } else if (this.userRole === 'organ') {
        request = tutorial.getPersonTutorialByOrg
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club' || this.userRole === 'leader' || this.userRole === 'coach') {
        request = tutorial.getPersonTutorialByYouth
      }
      request({ authorUserUuid: this.coachUuid, size: 2 }).then(res => {
        this.tutorial = res.content
        this.total = res.totalElements
      })
    },
    // 获取可查看所属球队名单
    getWhiteUuidList() {
      let request = null;
      const whiteUuidList = [];
      try {
        if (this.userRole === "system" || this.userRole === "admin") {
          // request = squad.getOrgListBySystem;
          // 系统管理员不做处理
          return;
        } else if (this.userRole === "organ") {
          request = squad.getOrgListByOrgan;
          request().then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
            if (res.length === 1) {
              res.forEach((orgItem) => {
                whiteUuidList.push(orgItem.organUuid);
              });
              this.whiteUuidList = whiteUuidList;
            } else {
              console.error("error:当前登录协会存在多个协会数据");
              this.whiteUuidList = [];
            }
          });
        } else if (
          this.userRole === "youth" ||
          this.userRole === "trainCamp" ||
          this.userRole === "club"
        ) {
          request = squad.getOrgListByYouth;
          request().then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
            if (res.length === 1) {
              if (res[0].youthList.length === 1) {
                res[0].youthList.forEach((youthItem) => {
                  whiteUuidList.push(youthItem.uuid);
                });
                this.whiteUuidList = whiteUuidList;
              } else {
                console.error("error:当前登录青训中心存在多个青训中心角色数据");
                this.whiteUuidList = [];
              }
            } else {
              console.error("error:当前登录协会存在多个协会数据");
              this.whiteUuidList = [];
            }
          });
        } else if(this.userRole === 'coach') {
          request = squad.getSquadListCoachAll
          request().then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
            if(res.length) {
              res.forEach(squadItem => {
                whiteUuidList.push(squadItem.squadUuid)
              })
              this.whiteUuidList = whiteUuidList;
            } else{
              console.error("error:当前登录教练不存在球队信息");
            }
          });
        }
      } catch (err) {
        console.error("err", err);
      }
    },
    goSquad (row) {
      const { squadUuid } = row;
      if(this.userRole === 'system' || this.userRole === 'admin') {
        this.$router.push({
          path: '/squad/detail',
          query: {
            uuid: squadUuid
          }
        })
      } else if(this.userRole === 'organ') {
        const { organUuid } = row;
        if(this.whiteUuidList.includes(organUuid)) {
          this.$router.push({
            path: '/squad/detail',
            query: {
              uuid: squadUuid
            }
          })
        } else {
          this.$message.error('很抱歉，您当前没有权限访问该球队信息!')
        }
      } else if(this.userRole === 'youth' || this.userRole === 'club' || this.userRole === 'trainCamp') {
        const { youthUuid } = row;
        if(this.whiteUuidList.includes(youthUuid)) {
          this.$router.push({
            path: '/squad/detail',
            query: {
              uuid: squadUuid
            }
          })
        } else {
          this.$message.error('很抱歉，您当前没有权限访问该球队信息!')
        }
      } else {
        console.error('login user role has error')
      }
    },
    goDetail (uuid) {
      this.$router.push({
        path: '/tutorial/detail',
        query: { uuid }
      })
    },
    goTutorial () {
      this.$router.push({
        path: 'tutorial',
        query: {
          uuid: this.coach.uuid,
          name: this.coach.idName
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.scroll_wrap
  height 100%
  padding 20px 0 10px 20px
  box-sizing border-box
  overflow hidden
  .info_item
    margin 0 30px 30px 10px
    .info_title
      font-size 20px
      padding 10px 0 20px
      display flex
      align-items center
      img
        margin-right 10px
        width 26px
      &.between
        justify-content space-between
        .flex_box
          display flex
          align-items center
        .tutorial
          span
            padding-right 10px
            padding-left 5px
            &:last-child
              padding-right 5px
      .yioks_btn
        padding 6px 20px
      .more
        padding-right 10px
        cursor pointer
    .base_info
      border 1px solid #FFF
      .col
        border-bottom 1px solid
        padding 16px 30px
        display flex
        justify-content space-around
        span
          display inline-block
          width 100%
        &:last-child
          border none
    .score_wrap
      display flex
      flex-wrap wrap
      .pie
        width 45%
        padding-right 5px
        height 100%
        border-right 1px solid $color_white
        box-sizing border-box
      .bar
        width 55%
        height 100%
        padding-left 5px
      .score_item
        padding-bottom 20px
        width 395px
        cursor pointer
        &:nth-child(odd)
          margin-right 40px
        .header
          height 30px
          background url('~@/assets/images/common/squad_bg.png') no-repeat
          background-size 261px 30px
          line-height 30px
          padding-left 15px
          font-size 18px
        .content
          border 1px solid #FFF
          padding 20px 15px
          display flex
          img
            width 54px
            height 80px
            margin-right 10px
          .score_info
            p
              margin-bottom 10px
              span
                margin-right 20px
                &:last-child
                  margin 0
    .tutorial_wrap
      display flex
      justify-content space-between
      .item_box
        background rgba(0, 0, 0 ,.35)
        border 2px solid transparent
        padding 20px
        width 410px
        cursor pointer
        &:hover
          background rgba(0,0,0,.35) url('~@/assets/images/common/hover_yioks.png') no-repeat right center
          box-shadow inset 0 0 12px $green_color
          border 2px solid $green_color
        .flex_box
          display flex
          border-bottom 1px solid #FFF
          padding-bottom 15px
          img
            margin-right 20px
            height 100px
            width 170px
          p
            width 145px
            text-overflow ellipsis
            overflow hidden
            white-space nowrap
        .info
          display flex
          div
            margin-right 20px
            &:last-child
              margin 0
          p
            margin-top 10px
  .manageSquad_wrap
    .el-row
      margin-bottom 20px
      .el-col
        line-height 40px
        text-align center
    .btn_wrap
      display flex
      justify-content center
      padding-top 20px
</style>
